import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class HexacoLine extends AbstractChart {
    protected allChartOptions(): Options {
        const $aggreagate = $(this.target).next();

        const data = $aggreagate.data("values");
        const chartId = $aggreagate.data("id");
        const seriesLabels = $aggreagate.data("labels");
        const seriesSettings = $aggreagate.data("settings");
        const dataLenght = data[Object.keys(data)[0]].length;
        const rowHeight = 87;
        const marginTop = 40;
        const width = 460;
        const minYAxis = 20;
        const maxYAxis = 80;
        const marginBottom = 10;
        const height = dataLenght * rowHeight + marginTop + marginBottom;
        const plotLinesWidth = 1;
        const plotLinesColor = 'white';
        const plotLinesXAxis = [];
        const plotLinesYAxis = [];
        const categoriesXAxis = [];
        const series = [];

        $.each(data, function (key, values) {
            const serieSettings = seriesSettings[key];
            series.push({
                name: seriesLabels[key],
                zIndex: serieSettings.zIndex,
                color: serieSettings.color,
                marker: {
                    symbol: serieSettings.symbol
                },
                lineWidth: 2,
                dashStyle: serieSettings.dashStyle,
                data: values
            });

        });
        for (let i = 0.5; i < dataLenght - 1; i++) {
            plotLinesXAxis.push({
                value: i,
                color: plotLinesColor,
                width: plotLinesWidth,
                zIndex: 1
            });
            categoriesXAxis.push(''); // We don't display categories. Add empty ones instead, which works better then using none.
        }
        for (let j = minYAxis; j < maxYAxis; j += 5) {
            plotLinesYAxis.push({
                value: j,
                color: plotLinesColor,
                width: plotLinesWidth,
                zIndex: 1
            });
        }
        const options: Options = {
            chart: {
                type: 'line',
                inverted: true,
                width: width,
                marginLeft: 12,
                marginRight: 12,
                marginTop: marginTop,
                marginBottom: marginBottom,
                height: height,
                style: {
                    fontFamily: '"Roboto", Helvetica, Arial, sans-serif'
                },
                events: {
                    load: function () {

                        $(this.series).each(function (i, serie) {
                            const legendSymbol = '<svg><g><g>' +
                                '<path fill="none" d="' + serie.legendItem.line.d + '" stroke-dasharray="' + serie.legendItem.line.attr('stroke-dasharray') + '"  stroke="' + serie.color + '" stroke-width="1"></path>' +
                                '<path fill="' + serie.color + '" d="' + serie.legendItem.symbol.d + '"></path>' +
                                '</g></g></svg>';

                            $.each(serie.yData, function (i, y) {
                                $('<li><span style="color:' + serie.color + ' !important" >' + y + '</span></li>').appendTo('#norm-values-' + chartId + '-' + i);
                            });
                            $('<li>' + legendSymbol + '<span>' + serie.name + '</span></li>').click(function () {
                                serie.visible ? serie.hide() : serie.show();
                            }).appendTo('#legend-' + chartId);
                        });

                        this.legend.group.hide();
                        this.legend.box.hide()

                    }
                }
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            title: {
                text: null
            },
            xAxis: {
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                tickWidth: 0,
                plotLines: plotLinesXAxis,
                categories: categoriesXAxis
            },
            yAxis: {
                min: minYAxis,
                max: maxYAxis,
                tickInterval: 1,
                opposite: true,
                offset: -6,
                title: {
                    text: null
                },
                labels: {
                    style: {
                        "color": "black",
                        "fontSize": "7pt"
                    },
                    y: -9,
                    useHTML: true
                },
                tickPositions: [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80],
                plotBands: [
                    {
                        color: '#c1c1c1',
                        from: 20,
                        to: 40
                    }, {
                        color: '#d7d7d7',
                        from: 40,
                        to: 60
                    }, {
                        color: '#c1c1c1',
                        from: 60,
                        to: 80
                    }
                ],
                plotLines: plotLinesYAxis
            },
            legend: {
                enabled: true
            },
            tooltip: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            series: series
        };
        options.yAxis.labels.formatter = function () {
            if (this.value === 40) {
                return '-s<br/>' + this.value;
            }
            if (this.value === 50) {
                return 'm<br/>' + this.value;
            }
            if (this.value === 60) {
                return '+s<br/>' + this.value;
            }
            return this.value.toString();
        };
        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {
    registerPlugin(HexacoLine)
}